import { type Common } from '../common.js';
import {
  type CreateValues,
  type PhoneNumberCapabilityRow,
  type UpdateValues,
} from '../models/phoneNumber/phoneNumberCapability.js';

export interface FindAllOptions {
  phoneNumberId?: string;
}

export class API {
  common: Common;
  readonly baseEndpoint = '/phone-number-capabilities';

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: CreateValues): Promise<PhoneNumberCapabilityRow> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async createBulk(capabilities: CreateValues[]): Promise<PhoneNumberCapabilityRow[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/bulk`);
    return await this.common.postJSON(url, { capabilities });
  }

  async update(id: string, values: UpdateValues): Promise<PhoneNumberCapabilityRow> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async delete(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
